import { facultyData } from '../facultyData';

export const computerScienceData = {
  departmentName: "Department of Computer Science",
  bannerImage: "/infrastructure/computerscience/lab-1.JPG",
  
  about: {
    title: "About the Department",
    content: `The Department of Computer Science offers cutting-edge education in computing technologies, 
    artificial intelligence, machine learning, and software development. We focus on industry-relevant skills 
    and research-oriented learning.`,
    highlights: [
      "State-of-the-art computer labs",
      "Focus on AI and Machine Learning",
      "Industry collaborations and internships",
      "Strong placement record in IT sector"
    ]
  },

  brochure: {
    title: "Department Brochure",
    pdfLink: "/computerscience/department-brochure.pdf",
    description: "Download our department brochure."
  },

  hod: {
    id: "cs001",
    name: "Dr. G. Ravi Kumar",
    designation: "Assistant Professor & Coordinator",
    photo: "/computerscience/ravi.JPG",
    email: "grkondaravi@gmail.com",
    mobile: "8555919531",
    qualification: "M.C.A., M.Tech, M.Phil., Ph.D.",
    specialization: "Artificial Intelligence, Machine Learning, Big Data Analytics",
    message: `Welcome to the Department of Computer Science.`,
    profileLink: "/computerscience/GORMANUKONDA.pdf"
  },

  bos: {
  title: "Computer Science",
  members: [
    {
      name: "Prof. Venkata Sundaranand Putcha",
      designation: "Chairperson",
      affiliation: "Dept. of Mathematics, Rayalaseema University, Kurnool"
    },
    {
      name: "Prof. B. Satyanarayana",
      designation: "Member",
      affiliation: "Dept. of CST, S.K. University, Anantapur"
    },
    {
      name: "Prof. C. Nagaraju",
      designation: "Member",
      affiliation: "Dept. of CSE, YSR Engineering College, Proddatur"
    },
    {
      name: "Prof. G. Anjan Babu",
      designation: "Member",
      affiliation: "Dept. of Computer Science, S.V. University, Tirupati"
    },
    {
      name: "Prof. P. Chenna Reddy",
      designation: "Member",
      affiliation: "Dept. of CSE, JNTUA, Anantapur"
    }
  ]
}
,

  faculty: facultyData.computerScience.faculty,

  courses: {
    undergraduate: [
      {
        name: "B.Sc. Computer Science",
        duration: "3 Years",
        eligibility: "10+2 with Mathematics",
        intake: "60 seats"
      }
    ],
    postgraduate: [
      {
        name: "M.Sc. Computer Science",
        duration: "2 Years",
        eligibility: "B.Sc. Computer Science",
        intake: "30 seats"
      },
      {
        name: "Master of Computer Application",
        duration: "2 Years",
        eligibility: "B.Sc. Computer Science",
        intake: "30 seats"
      }
    ],
    // research: [
    //   {
    //     name: "Ph.D. in Computer Science",
    //     duration: "Minimum 3 Years",
    //     eligibility: "M.Sc. Computer Science",
    //     areas: "AI, Machine Learning, Data Science, Cloud Computing"
    //   }
    // ] 
  },

 Infrastructure: [
 

  "/infrastructure/computerscience/lab-1.JPG",

  "/infrastructure/computerscience/lab-2.JPG",
 
]
};